export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;
  const publicPaths = ['/auth/login', '/auth/register', '/auth/Login', '/auth/Register'];
  if (publicPaths.some((p) => to.path.toLowerCase() === p.toLowerCase())) return;

  try {
    const raw = localStorage.getItem('jgi_auth');
    if (!raw) return navigateTo('/auth/login');

    // Idle 24 jam tanpa aktivitas → paksa login ulang
    try {
      const { isIdleExpired } = await import('@/composables/useIdleSession');
      if (isIdleExpired()) {
        localStorage.removeItem('jgi_auth');
        try {
          await $fetch('/api/auth/logout', { method: 'POST' });
        } catch {
          /* ignore */
        }
        return navigateTo('/auth/login?reason=idle');
      }
    } catch {
      /* ignore idle check errors */
    }
  } catch {
    return navigateTo('/auth/login');
  }

  try {
    const me = await $fetch<{
      authenticated?: boolean;
      menus?: string[] | '*';
      canManageUsers?: boolean;
    }>('/api/auth/me');
    if (!me?.authenticated) {
      try {
        localStorage.removeItem('jgi_auth');
      } catch {
        /* ignore */
      }
      return navigateTo('/auth/login');
    }

    const path = to.path.split('?')[0] || '/';
    if (path === '/' || path.startsWith('/auth')) return;

    // Akun pribadi — semua user login boleh akses
    if (path === '/account' || path.startsWith('/account/')) return;

    // Halaman kelola user
    if (path === '/users' || path.startsWith('/users/')) {
      if (!me.canManageUsers) return navigateTo('/');
      return;
    }

    const menus = me.menus;
    if (!menus || menus === '*' || (Array.isArray(menus) && menus.includes('*'))) return;

    const { pathAllowed } = await import('@/utils/menuAcl');
    if (!pathAllowed(path, menus)) {
      return navigateTo('/');
    }
  } catch {
    try {
      localStorage.removeItem('jgi_auth');
    } catch {
      /* ignore */
    }
    return navigateTo('/auth/login');
  }
});
